export default {
  meta: {
    title: '开发部绩效报表（一鸣）'
  }
};
